import React from 'react';
import { Button, Tooltip } from '@duxton-web/ui';

import { useExperimentContext } from '../../contexts/experiment-context';

const SupersetButton = () => {
  const experimentContext = useExperimentContext();
  const { analysis } = experimentContext;
  const hasMetrics = !!(
    analysis?.analysisConfig?.guardrail_metrics?.length ||
    analysis?.analysisConfig?.primary_metrics?.length ||
    analysis?.analysisConfig?.secondary_metrics?.length
  );

  if (hasMetrics)
    return (
      <Button
        type="secondary"
        size="small"
        href={analysis?.supersetLink}
        target="_blank"
      >
        Check results in Superset
      </Button>
    );

  return (
    <Tooltip title="No metric associated with the experiment.">
      <Button type="secondary" size="small" disabled>
        Check results in Superset
      </Button>
    </Tooltip>
  );
};

export default SupersetButton;
